import ChatBody from "features/Chat/ChatBody";
import ChatDoc from "features/Chat/ChatDoc";
import ChatSideBar from "features/Chat/ChatSidebar";
import Vc from "features/Chat/Vc";
import React, { Fragment, useState } from "react";
import useStyles from "./ChatStyles";

const isSmallScreen = (width) => {
  return width < 960;
};

const getMobileStepContent = (
  step,
  classes,
  selected,
  setSelected,
  setStep,
  screenWidth,
  openDoc,
  profileType
) => {
  switch (step) {
    case 0:
    default:
      return (
        <ChatSideBar
          classes={classes}
          selected={selected}
          setSelected={setSelected}
          setStep={setStep}
        />
      );
    case 1:
      return (
        <ChatBody
          selected={selected}
          classes={classes}
          rightDocOpen={openDoc}
          smallScreen={isSmallScreen(screenWidth)}
          setStep={setStep}
        />
      );
    case 2:
      return (
        <ChatDoc
          classes={classes}
          setStep={setStep}
          selected={selected}
          smallScreen={isSmallScreen(screenWidth)}
          profileType={profileType}
        />
      );
  }
};

const DesktopChat = ({
  classes,
  selected,
  setSelected,
  setStep,
  screenWidth,
  openDoc,
  profileType,
}) => {
  return (
    <Fragment>
      <ChatSideBar
        classes={classes}
        selected={selected}
        setSelected={setSelected}
        setStep={setStep}
      />
      <ChatBody
        selected={selected}
        classes={classes}
        rightDocOpen={openDoc}
        smallScreen={isSmallScreen(screenWidth)}
        setStep={setStep}
      />
      <ChatDoc
        classes={classes}
        setStep={setStep}
        selected={selected}
        smallScreen={isSmallScreen(screenWidth)}
        profileType={profileType}
      />
    </Fragment>
  );
};

const MobileChat = ({
  step,
  classes,
  selected,
  setSelected,
  setStep,
  screenWidth,
  openDoc,
}) => {
  return (
    <Fragment>
      {getMobileStepContent(
        step,
        classes,
        selected,
        setSelected,
        setStep,
        screenWidth,
        openDoc
      )}
    </Fragment>
  );
};

export default function Chat({
  screenWidth,
  showVC,
  selected,
  setSelected,
  profileType,
}) {
  const [docOpen, setOpen] = useState(true);
  const [step, setStep] = useState(0);
  const classes = useStyles({
    docOpen,
    smallScreen: isSmallScreen(screenWidth),
  });

  const openDoc = () => {
    setOpen((prevState) => !prevState);
  };

  const childProps = {
    step,
    classes,
    selected,
    setSelected,
    setStep,
    screenWidth,
    openDoc,
    profileType,
  };

  return (
    <div className={classes.root}>
      {/* <CssBaseline /> */}

      {!showVC ? (
        isSmallScreen(screenWidth) ? (
          <MobileChat {...childProps} />
        ) : (
          <DesktopChat {...childProps} />
        )
      ) : (
        <Fragment>
          <Vc />
          <ChatBody
            selected={selected}
            classes={classes}
            rightDocOpen={openDoc}
            smallScreen={isSmallScreen(screenWidth)}
            setStep={setStep}
          />
        </Fragment>
      )}
    </div>
  );
}
